























import Vue from 'vue';
import NOC from '@/class/common/const';

export default Vue.extend({
  name: 'TermsFooter',
  data() {
    return {
      links: [
        {text: '利用規約', value: `/service/terms-of-use/`},
        {text: '|'},
        {text: '特定商取引法に基づく表記', value: `/service/terms-of-sale/`},
        {text: '|'},
        {text: '個人情報保護方針', value: `https://idh-net.co.jp/privacy-policy/`},
        {text: '|'},
        {text: 'お問い合わせ', value: `/service/contact`},
        {text: '|'},
      ],
      sns: [
        {text: ' Twitter', value: `https://twitter.com/idh_net4all`, class: 'fa-twitter'},
        {text: '|'},
        {text: ' Facebook', value: `https://www.facebook.com/idh4all`, class: 'fa-facebook-square'},
        {text: '|'},
        {text: ' Instagram', value: `https://www.instagram.com/idh_net4all/`, class: 'fa-instagram'},
      ],
    };
  },
});
